import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useGetStep } from 'shared/hooks'
import { SpinnerLoader } from 'shared/ui'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useProgressInfoTitle } from 'pages/settings/pages/inboxes/pages/newInbox/hooks/useProgressInfoTitle'
import { useNewInboxStepsContext } from '../context/newInboxStepsContext'
import { type NewInboxRoutesSteps } from '../store/newInboxStepsStore'

export const NewInboxStepsLayout = observer(() => {
  const {
    redirectToRoot,
    allStepsLength,
    decreaseStep,
    setCurrentStep,
    getSettingsStep,
    textEnableLandlineStore: { init, loading },
    hideBack,
  } = useNewInboxStepsContext()
  const settingsStep = useGetStep<NewInboxRoutesSteps>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()
  const { search } = useLocation()

  useEffect(() => {
    init(search)
  }, [])

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep])

  if (loading) {
    return <SpinnerLoader ariaLabel={'NewInboxStepsLayout'} />
  }

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='New inbox'
      settingsStep={settingsStep}
      closeSetting={redirectToRoot}
      decreaseStep={decreaseStep}
      hideBack={hideBack}
    />
  )
})
